"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.parseMonthYear = parseMonthYear;
exports.parseSeasonYear = parseSeasonYear;

var _uiwidgetsCommon = require("uiwidgets-common");

var _DateParser = require("./DateParser");

var _DateParser2 = _interopRequireDefault(_DateParser);

var _ParseUtils = require("./ParseUtils");

var _Seasons = require("./Seasons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var regx = /([^\s\.\/\\,-]+)(?:[\s\.\/\\,-]+([^\s\.\/\\,-]+))?/;

exports.default = function (s, opts) {
    var match, result, year;

    // trim the string before doing anything.
    s && (s = s.trim().toLowerCase());

    // no string / empty string, null value.
    if (!s) {
        return null;
    }

    opts || (opts = {});

    // if someone types 'today' return todays date.
    if (s === 'today') {
        var now = new Date(opts.now || Date.now());
        now.setUTCHours(0, 0, 0, 0);
        return {
            type: "date",
            start: now,
            end: now
        };
    }

    result = (0, _DateParser2.default)(s, opts);
    if (result) {
        return {
            type: "date",
            start: result,
            end: result
        };
    }

    // attempt to parse
    match = regx.exec(s);
    if (match[2]) {
        // matched two groups, lets treat the second as a year...
        year = (0, _ParseUtils.parseYear)(match[2]);

        // if year is not a number, then it can't be season/year or month/year.
        if (!(0, _uiwidgetsCommon.isUndefined)(year)) {
            // and for the first... try a season...
            result = parseSeasonYear(match[1], year, opts);
            if ((0, _uiwidgetsCommon.isUndefined)(result)) {
                // ... and then a month.
                result = parseMonthYear(match[1], year);
            }
        }
    } else {
        // matched only one group.
        year = new Date().getFullYear();
        result = parseMonthYear(match[1], year);
    }

    return result;
};

/**
 * Parse the string as a month. If the month is able to be derived from the given string, the start and end dates of
 * the month are calculated (using the given year).
 *
 * @param month {String} the month string to parse.
 * @param year {Number} the year.
 * @returns {Object} a date range using the start and end dates of the month or undefined
 */


function parseMonthYear(month, year) {
    var m = (0, _ParseUtils.parseMonth)(month),
        result;

    if (!(0, _uiwidgetsCommon.isUndefined)(m)) {
        result = {
            start: new Date(Date.UTC(year, m, 1)),
            end: new Date(Date.UTC(year, m + 1, 0)),
            type: "month/year"
        };
    }

    return result;
}

/**
 * Parse the string as a season, where necessary, using the given year to get accurate dates.
 *
 * @param s {String} the season string.
 * @param year {Number} the year.
 * @param opts {Object} the configuration object.
 *   @param opts.lang {String} the BCP-47 language code, defaults to "en".
 *   @param opts.seasonType {String} 'astronomical' or 'meteorological' (default).
 * @returns {Object} a date range for the season/year or undefined.
 */
function parseSeasonYear(s, year, opts) {
    var lang = opts.lang || "en";
    var seasonKey = (0, _Seasons.parseSeason)(s, lang);

    var result = void 0;

    if (seasonKey) {
        var meteorological = opts.seasonType !== "astronomical";
        var getSeason = meteorological ? _Seasons.getMeteorologicalSeason : _Seasons.getAstronomicalSeason;
        var range = getSeason(seasonKey, year);

        if (range) {
            result = _extends({ type: "season/year" }, range);
        }
    }

    return result;
}
//# sourceMappingURL=DateParserFuzzy.js.map